import { render, staticRenderFns } from "./BasicChart.vue?vue&type=template&id=36191f84&scoped=true&"
import script from "./BasicChart.vue?vue&type=script&lang=js&"
export * from "./BasicChart.vue?vue&type=script&lang=js&"
import style0 from "./BasicChart.vue?vue&type=style&index=0&id=36191f84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36191f84",
  null
  
)

export default component.exports